import { render, staticRenderFns } from "./bar-order-constructor-dishs.vue?vue&type=template&id=764b9072&"
import script from "./bar-order-constructor-dishs.vue?vue&type=script&lang=ts&"
export * from "./bar-order-constructor-dishs.vue?vue&type=script&lang=ts&"
import style0 from "./bar-order-constructor-dishs.vue?vue&type=style&index=0&id=764b9072&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports